import { GET_CURRENT_USER } from '../graphql/GET_CURRENT_USER';
import { storage } from './storage';

export const accessTokenStorage = storage<string>('token');
export const blockedMessageStorage = storage<string>('blockedMessage');

export const logout = (message?: string) => {
  accessTokenStorage.clear();
  if (message) {
    blockedMessageStorage.set(message);
  }
  window.location.href = '/landing';
};

export const isLoggedIn = async apolloClient =>
  apolloClient
    .query({ query: GET_CURRENT_USER })
    .then(response => {
      return { user: response.data };
    })
    .catch((e: Error) => {
      accessTokenStorage.clear();
    });
